import React from 'react';
import { arrayOf, func, shape } from 'prop-types';

import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';

const SelectedAuthorizations = ({
  selectedAuthorizations,
  setSelectedAuthorizations,
  setShowSelectedAuthorizations,
}) => (
  <Stack alignItems="flex-start" direction="column" sx={{ mx: 2, my: 1 }}>
    {selectedAuthorizations.map(({ customerId, customerName }) => (
      <Chip
        key={customerId}
        label={`${customerId} ${customerName}`}
        onDelete={() => {
          const filteredAuths = selectedAuthorizations.filter(
            auth => auth.customerId !== customerId
          );

          setSelectedAuthorizations(filteredAuths);
          setShowSelectedAuthorizations(!!filteredAuths.length);
        }}
        sx={{
          borderColor: 'primary.main',
          my: 0.4,
        }}
        variant="outlined"
      />
    ))}
  </Stack>
);

SelectedAuthorizations.propTypes = {
  selectedAuthorizations: arrayOf(shape({})).isRequired,
  setSelectedAuthorizations: func.isRequired,
  setShowSelectedAuthorizations: func.isRequired,
};

export default SelectedAuthorizations;
